<template>
  <div>
    <!-- @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave" -->
    <el-table
      stripe
      :key="key"
      :data="data"
      :span-method="spanMethod"
      :row-class-name="tableRowClassName"
      style="width: 100%"
      v-bind="$attrs"
      v-on="$listeners"
      header-align="center"
      :header-cell-style="headCellStyle"
      :cell-style="bodyCellStyle"
    >
      <slot></slot>
      <p
        slot="append"
        class="more"
        v-loading="isloadings"
      >
        <a href="javascript:;" @click="getMData()">{{ txt }}</a>
      </p>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'MergeTable',
  props: {
    // 表格数据
    data: {
      type: Array,
      default: () => [],
    },
    // 根据某字段标识计算合并
    mark: {
      type: String,
      default: 'id',
    },
    // 需要合并的列字段
    markField: {
      type: Array,
      default: () => [],
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: false,
      tableData: [],
      spanArr: [],
      position: 0,
      // needSpan: ["id", "name"], // 需要合并的属性
      needSpan: [], // 需要合并的属性
      spanArrObj: {},
      // spanArrObj: {
      //   id: [],
      //   name: []
      // },
      rowIndex: '-1',
      OrderIndexArr: [],
      hoverOrderArr: [],
      key: '1',
    }
  },
  computed: {
    isloadings: {
      get: function () {
        return this.isloading
      },
      set: function (val) {
        this.$emit('update:isloading', val) //可以优化成model  或者minx
      },
    },
    txt: {
      get: function () {
        return this.text || this.$t('buttonTitle.clickSeeMore')
      },
      set: function (val) {
        this.$emit('update:text', val) //可以优化成model  或者minx
      },
    },
  },
  created() {
    // this.getSpanArr();
  },
  watch: {
    // 监听数据变动
    data(val) {
      this.tableData = val
      // 清空缓存，重新计算
      this.OrderIndexArr = []
      this.getSpanArr()
      this.getOrderNumber()
      this.key = new Date().getTime()
    },
  },
  mounted() {
    this.needSpan = this.markField
    this.tableData = this.data
    this.getSpanArr()
    this.getOrderNumber()
  },
  methods: {
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      var data
      this.needSpan.forEach((e) => {
        if (column.property === e) {
          const _row = this.spanArrObj[e][rowIndex]
          const _col = _row > 0 ? 1 : 0
          data = {
            rowspan: _row,
            colspan: _col,
          }
        }
      })
      return data
    },
    // 获取合并行参数(数组)
    rowspan(prop, first) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArrObj[prop].push(1)
          this.position = 0
        } else {
          if (
            this.tableData[index][first] === this.tableData[index - 1][first] &&
            this.tableData[index][prop] === this.tableData[index - 1][prop]
          ) {
            this.spanArrObj[prop][this.position] += 1
            this.spanArrObj[prop].push(0)
          } else {
            this.spanArrObj[prop].push(1)
            this.position = index
          }
        }
      })
    },
    getSpanArr() {
      this.needSpan.forEach((item) => {
        this.spanArrObj[item] = []
        this.rowspan(item, this.mark)
      })
    },
    tableRowClassName({ row, rowIndex }) {
      var arr = this.hoverOrderArr
      for (var i = 0; i < arr.length; i++) {
        if (rowIndex === arr[i]) {
          return 'success-row'
        }
      }
    },

    // 鼠标滑出事件
    cellMouseEnter(row, column, cell, event) {
      this.rowIndex = row.rowIndex
      this.hoverOrderArr = []
      this.OrderIndexArr.forEach((element) => {
        if (element.indexOf(this.rowIndex) >= 0) {
          this.hoverOrderArr = element
        }
      })
    },
    // 鼠标滑入事件
    cellMouseLeave(row, column, cell, event) {
      this.rowIndex = '-1'
      this.hoverOrderArr = []
    },

    // 获取相同编号的数组
    getOrderNumber() {
      var OrderObj = {}
      this.tableData.forEach((element, index) => {
        element.rowIndex = index
        if (OrderObj[element[this.mark]]) {
          OrderObj[element[this.mark]].push(index)
        } else {
          OrderObj[element[this.mark]] = []
          OrderObj[element[this.mark]].push(index)
        }
      })

      for (var k in OrderObj) {
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k])
        }
      }
    },
    getMData() {
      if (this.txt == this.$t('public.btn_noMore')) {
        this.isloadings = false
      } else {
        this.isloadings = true
      }
      this.$emit('pageAdd')

      // this.$parent.tableForm
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-table .success-row {
  background: #f5f7fa;
}
::v-deep.el-table::before{
  height: 0;
}
// 鼠标移入表格的颜色
.more{
  list-style: 50px;
  text-align: center;
  margin: 10px 0;
}
</style>
